<template>
  <section
    v-if="applicationType == 'Commercial' ? allowCommercial : true"
    :class="['step-content', {
      'collapsible-section': !noExpand,
      'disable-organise': noOrganise
    }]"
    ref="section"
    :style="{ height: closed ? closedHeight : openedHeight, overflow: hideOverflow ? 'hidden' : 'visible' }"
  >
    <div class="animated-expander" @click="expand" v-if="!noExpand && enabled">
      <button :class="['button', closed ? '' : 'on']">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <slot />
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'CollapsibleSection',
  components: {},
  props: {
    noExpand: Boolean,
    noOrganise: Boolean,
    allowCommercial: {
      type: Boolean,
      default: false
    },
    collapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      closed: false,
      hideOverflow: false,
      closedHeight: null,
      openedHeight: 'auto'
    }
  },
  computed: {
    ...mapGetters({
        applicationType: "summary/applicationType",
        applicationView: "userSettings/applicationView",
    }),
    enabled() {
      return Ambition.getGlobal('tenant.enable_ignition_styles') || Ambition.isIgnition()
    }
  },
  watch: {},
  mounted() {
      if (this.collapse) {
        this.expand();
      }
  },
  updated() {},
  activated() {},
  methods: {
    findClosedHeight() {
      const hPadding = 0
      const h =
        $(this.$refs.section)
          .find('.hr-title')
          .first()
          .outerHeight(true) + hPadding
      const hPx = `${h}px`

      return hPx
    },

    expand() {
      // Simple but no smooth transition of height property
      // this.closed = !this.closed

      // Open / Close with delays for smooth height transition
      const h = $(this.$refs.section).outerHeight(true)
      //

      if (this.closed) {
        // Open
        this.closed = false
        setTimeout(() => {
          this.openedHeight = `auto`
        }, 250)
        setTimeout(() => {
          this.hideOverflow = false
        }, 250)
      } else {
        // Close
        this.openedHeight = `${h}px`
        this.closedHeight = this.findClosedHeight()
        setTimeout(() => {
          this.hideOverflow = true
        })
        setTimeout(() => {
          this.closed = true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';

.collapsible-section {
  transition: all 0.25s ease-in;
  position: relative;
  // overflow: hidden;
}
.expander-toggle,
.animated-expander {
  $padding: 0px;
  z-index: 20;
  position: absolute;
  top: $padding;
  right: $padding;
  // border: 1px solid red;
  svg {
    // font-size: 26px;
  }
}
</style>

<style lang="scss" scoped>
@import "@assets/sass/backend/_core-variables.scss";

$size: 30px;
$color: rgba(#222, 0.5);
$barHeight: 2px;
$borderWidth: 2px;

.animated-expander {
  .button {
    // position: absolute;
    position: relative;
    width: $size;
    height: $size;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    cursor: pointer;
    // background: $color;
    // background: rgba($color, 0.05);
    // background: #fff;
    background: transparent;
    border: none;
    // border: $borderWidth solid $color;
    border-radius: 50%;
    outline: none;
  }

  .button span {
    position: absolute;
    width: 50%;
    height: $barHeight;
    top: 50%;
    left: 50%;
    // background: #262626;
    background: $color;
    // border-radius: 2px;
    overflow: hidden;
    transition: all 0.3s linear;
  }

  .button span::before {
    content: "";
    position: absolute;
    width: 0;
    height: 100%;
    top: 0;
    right: 0;
    background: gray;
    transition: all 0.3s linear;
  }

  .button span:nth-child(1) {
    animation: span-first-off 0.5s ease-in-out;
    animation-fill-mode: forwards;
  }

  .button span:nth-child(2) {
    animation: span-second-off 0.5s ease-in-out;
    animation-fill-mode: forwards;
  }

  .button span:nth-child(3) {
    animation: span-third-off 0.5s ease-in-out;
    animation-fill-mode: forwards;
  }

  .button.on:hover span::before {
    width: 100%;
    transition: all 0.3s linear;
  }

  .button.on span:nth-child(1) {
    animation: span-first-on 0.5s ease-in-out;
    animation-fill-mode: forwards;
  }

  .button.on span:nth-child(2) {
    animation: span-second-on 0.5s ease-in-out;
    animation-fill-mode: forwards;
  }

  .button.on span:nth-child(3) {
    animation: span-third-on 0.5s ease-in-out;
    animation-fill-mode: forwards;
  }

  @keyframes span-first-on {
    0% {
      transform: translate(-50%, -300%);
    }
    30% {
      transform: translate(-50%, -50%);
    }
    100% {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  @keyframes span-first-off {
    0% {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
    30% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -300%);
    }
  }

  @keyframes span-second-on {
    0% {
      transform: translate(-50%, -50%);
    }
    25% {
      background: gray;
    }
    50% {
      transform: translate(-50%, -50%) scale(1);
    }
    100% {
      transform: translate(-150%, -50%) scale(0);
    }
  }

  @keyframes span-second-off {
    0% {
      transform: translate(-150%, -50%) scale(0);
    }
    25% {
      background: gray;
    }
    50% {
      transform: translate(-50%, -50%) scale(1);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }

  @keyframes span-third-on {
    0% {
      transform: translate(-50%, 200%);
    }
    30% {
      transform: translate(-50%, -50%);
    }
    100% {
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }

  @keyframes span-third-off {
    0% {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    30% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, 200%);
    }
  }
}

section.step-content.collapsible-section .animated-expander .button span,
.product-ignition-backend section.step-content.collapsible-section .animated-expander .button span {
    background-color: #ffffff !important;
}
</style>
